<template>
  <div class="userDetail" v-loading="loading">
    <!-- 修改姓名 -->
    <Dialog ref="dialog" :config="config">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <Dialog ref="dialog3" :config="config3">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <!-- 修改唛头-->
    <Dialog ref="dialog2" :config="config2">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <!-- 修改州 -->
    <Dialog ref="dialog5" :config="config5">
      <div class="modifydialog">
        <el-select class="option" :placeholder="$fanyi('请选择地区')" v-model="value">
          <el-option :label="$fanyi(item.key)" :value="item.value" v-for="(item, index) in $imdata.provincesList"
            :key="item + index">
          </el-option>
        </el-select>
      </div>
    </Dialog>
    <!-- 修改nif -->
    <Dialog ref="dialog6" :config="config4">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <!-- 修改手机号 -->
    <Dialog ref="dialogtel" :config="config6">
      <div class="modifydialog">
        <el-input v-model="value" :placeholder="$fanyi('请输入新手机号')"></el-input>
      </div>
    </Dialog>
    <!-- 修改WhatsApp-->
    <Dialog ref="dialog7" :config="config7">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <!-- 修改Telegram-->
    <Dialog ref="dialog9" :config="config9">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <!-- 修改MAX-->
    <Dialog ref="dialog8" :config="config8">
      <div class="modifydialog">
        <el-input v-model="value"></el-input>
      </div>
    </Dialog>
    <!-- 确认提示弹窗（Google 解绑 / 邀请码绑定等） -->
    <Dialog ref="confirmDialog" :config="confirmConfig"></Dialog>
    <nav>{{ $fanyi('基本信息') }}</nav>
    <div class="Con">

      <div class="ConOpt">
        <label> <span>{{ $fanyi('姓氏') }}： </span>

          <img @click="changeUserName('last_name')" src="../../../../assets/OrderDetails/edit.svg" alt="">
        </label>
        <div class="userMessage">

          <div class="istrueInput">{{ userDatas.user_last_name }} </div>


        </div>
      </div>
      <div class="ConOpt">
        <label><span>{{ $fanyi('名字') }}：</span> <img @click="changeUserName('name')"
            src="../../../../assets/OrderDetails/edit.svg" alt=""></label>
        <div class="userMessage">

          <div class="istrueInput">
            {{ userDatas.user_name }}
          </div>


        </div>
      </div>
      <div class="ConOpt">
        <label><span>{{ $fanyi('州') }}： </span> <img @click="changeUserName('zhou')"
            src="../../../../assets/OrderDetails/edit.svg" alt=""> </label>

        <div class="userMessage">
          <div class="istrueInput">
            {{ userDatas.state }}
          </div>


        </div>
      </div>
      <div class="ConOpt">
        <label><span>{{ $fanyi('电子邮箱') }}： </span> <img @click="$fun.toPage('/user/changepassword?type=email')"
            src="../../../../assets/OrderDetails/edit.svg" alt=""></label>
        <div class="userMessage">
          <div class="istrueInput">{{ userDatas.email }} </div>


        </div>
      </div>
      <!-- 手机号修改  changeUserName（Cell phone）-->
      <div class="ConOpt">
        <label><span>{{ $fanyi('手机') }}： </span>
          <img @click="changeUserName('Cellphone')" src="../../../../assets/OrderDetails/edit.svg" alt="">
        </label>
        <div class="userMessage">
          <div class="istrueInput">{{ userDatas.mobile }}</div>

        </div>
      </div>
      <div class="ConOpt">
        <label><span>{{ $fanyi('修改WhatsApp') }}： </span>

          <img @click="changeUserName('whatsapp')" src="../../../../assets/OrderDetails/edit.svg" alt="">
        </label>
        <div class="userMessage">
          <div class="istrueInput">{{ userDatas.whatsapp }}</div>

        </div>
      </div>
      <div class="ConOpt">
        <label><span>{{ $fanyi('修改Telegram') }}： </span>

          <img @click="changeUserName('telegram')" src="../../../../assets/OrderDetails/edit.svg" alt="">
        </label>
        <div class="userMessage">
          <div class="istrueInput">{{ userDatas.telegram }}</div>

        </div>
      </div>
      <div class="ConOpt">

        <label><span>{{ $fanyi('修改MAX') }}： </span>
          <img @click="changeUserName('max')" src="../../../../assets/OrderDetails/edit.svg" alt="">
        </label>
        <div class="userMessage">
          <div class="istrueInput">{{ userDatas.max }}</div>

        </div>
      </div>

      <!-- Google 快捷登录授权 -->
      <div class="ConOpt">
        <label><span>{{ $fanyi('google快捷登录授权：') }}</span></label>
        <div class="userMessage bind-row">
          <template v-if="isBindGoogle">
            <span class="istrueInput">{{ maskedGoogleEmail }}</span>
            <span class="bind-link" @click="unbindGoogle">{{ $fanyi('解除绑定') }}</span>
          </template>
          <span v-else class="bind-link" @click="getGoogleAuth">{{ $fanyi('获取google授权') }}</span>
          <div id="googleBindBtn" class="google-bind-btn"></div>
        </div>
      </div>

      <!-- 邀请码绑定 -->
      <div class="ConOpt">
        <label><span>{{ $fanyi('邀请码：') }}</span></label>
        <div class="userMessage bind-row">
          <!-- is_bound_lecturer=true：仅展示邀请码，隐藏按钮 -->
          <span v-if="isBoundLecturer" class="istrueInput">{{ userDatas.invite_code }}</span>
          <!-- is_bound_lecturer=false：展示输入框 + 绑定按钮（有 invite_code 时回填） -->
          <template v-else>
            <input class="promote-input" v-model="inviteCode" :placeholder="$fanyi('请输入邀请码')" />
            <span class="bind-link" @click="bindInviteCode">{{ $fanyi('绑定') }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Dialog from '../../../../components/public/Dialog.vue'
import GWT from 'jwt-decode'

export default {
  data() {
    return {
      userDatas: {},
      inviteCode: '',
      googleInitialized: false,
      value: '',
      showNIF: false, //显示身份证
      showpassword: false, //显示密码
      mark: '',
      markList: [],
      config: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改姓氏'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config2: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改唛头'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config3: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改名字'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config4: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改SSN'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config5: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改州'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config6: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改手机号'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config7: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改WhatsApp'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config9: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改Telegram'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      config8: {
        top: '35vh',
        width: '560px',
        title: this.$fanyi('修改MAX'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      confirmConfig: {
        top: '35vh',
        width: '520px',
        title: this.$fanyi('提示'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },

    }
  },
  components: { Dialog },
  computed: {
    /** 是否已绑定 Google（is_bind_google = true 时显示脱敏邮箱 + 解除绑定） */
    isBindGoogle() {
      return this.userDatas.is_bind_google == true
    },
    /** Google 邮箱脱敏显示 */
    maskedGoogleEmail() {
      return this.maskEmail(this.userDatas.google_email || '')
    },
    /** 是否已绑定讲师（true 时仅展示邀请码，隐藏绑定按钮） */
    isBoundLecturer() {
      return this.userDatas.is_bound_lecturer === true || this.userDatas.is_bound_lecturer == 1
    },
  },
  created() {
    this.getData()
    // this.getmark();
  },
  mounted() {
    this.initGoogleBind()
  },
  methods: {
    /** 获取用户资料 */
    getData() {
      this.loading = true
      this.$api.EuropegetUserInfo().then((res) => {
        this.loading = false
        if (res.code != 0) return this.message.error(res.msg)
        this.userDatas = res.data
        this.inviteCode = res.data.invite_code || ''
        this.$store.commit('userData', res.data)
      })
    },
    /**
     * 邮箱脱敏：保留 @ 前首位和末位，中间用 * 替换
     * @param {string} email
     */
    maskEmail(email) {
      if (!email) return ''
      const atIndex = email.indexOf('@')
      if (atIndex <= 0) return email
      const local = email.substring(0, atIndex)
      const domain = email.substring(atIndex)
      if (local.length <= 1) return local + domain
      if (local.length === 2) return local[0] + '*' + local[1] + domain
      return local[0] + '*'.repeat(local.length - 2) + local[local.length - 1] + domain
    },
    /** 初始化 Google 授权按钮（隐藏，通过点击链接触发） */
    initGoogleBind() {
      if (this.googleInitialized || typeof window.google !== 'object') return
      google.accounts.id.initialize({
        client_id: '317320225436-m0ukrfc759miu1rai2dv5lq6bc5te2mc.apps.googleusercontent.com',
        callback: this.handleGoogleBindResponse,
      })
      google.accounts.id.renderButton(
        document.getElementById('googleBindBtn'),
        { theme: 'outline', size: 'large' }
      )
      this.googleInitialized = true
    },
    /** 点击获取 Google 授权，触发隐藏的 Google 登录按钮 */
    getGoogleAuth() {
      this.$nextTick(() => {
        const btn = document.querySelector('#googleBindBtn .nsm7Bb-HzV7m-LgbsSe-MJoBVe')
        if (btn) {
          btn.click()
        } else {
          this.initGoogleBind()
          this.$nextTick(() => {
            const retryBtn = document.querySelector('#googleBindBtn .nsm7Bb-HzV7m-LgbsSe-MJoBVe')
            if (retryBtn) retryBtn.click()
          })
        }
      })
    },
    /**
     * Google 授权回调，获取 token 后绑定
     * @param {Object} response - Google 返回的 credential
     */
    async handleGoogleBindResponse(response) {
      if (!response.credential) {
        this.$message.error(this.$fanyi('google快捷登录绑定失败！请重试！'))
        return
      }
      try {
        const data = GWT(response.credential)
        const res = await this.$api.userGoogleBind({ google_token: data })
        if (res.code != 0) {
          if (res.msg && (res.msg.includes('其他账号') || res.msg.includes('已被绑定'))) {
            this.$message.error(this.$fanyi('此google邮箱已被其他账号绑定，请确认！'))
          } else {
            this.$message.error(this.$fanyi('google快捷登录绑定失败！请重试！'))
          }
          return
        }
        this.$message.success(this.$fanyi('google快捷登录绑定成功！'))
        this.getData()
      } catch {
        this.$message.error(this.$fanyi('google快捷登录绑定失败！请重试！'))
      }
    },
    /**
     * 打开确认弹窗（复用页面 Dialog 组件样式）
     * @param {string} title - 弹窗标题
     * @param {string} message - 提示内容
     * @param {Function} onConfirm - 点击确认回调，参数为关闭弹窗方法 cancel
     */
    openConfirmDialog(title, message, onConfirm) {
      this.confirmConfig.title = title
      if (this.$refs.confirmDialog) {
        this.$refs.confirmDialog.attributes.width = '520px'
      }
      this.$refs.confirmDialog.open(
        message,
        (cancel) => onConfirm(cancel),
        () => { }
      )
    },
    /** 解除 Google 账号绑定 */
    unbindGoogle() {
      this.openConfirmDialog(
        this.$fanyi('解除绑定'),
        this.$fanyi('是否解除google账号授权，解除后，将无法使用google账号'),
        (cancel) => {
          this.$api.userGoogleUnbind().then((res) => {
            cancel()
            if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))

            this.getData()
          })
        }
      )
    },
    /** 绑定邀请码：先校验，再确认绑定 */
    bindInviteCode() {
      const code = (this.inviteCode || '').trim()
      if (!code) {
        this.$message.warning(this.$fanyi('请输入邀请码'))
        return
      }
      this.$api.checkPromoteCode({ invite_code: code }).then((res) => {
        if (res.code != 0) {
          this.$message.error(this.$fanyi('未查询到此邀请码,请检查！'))
          this.inviteCode = ''
          return
        }
        this.openConfirmDialog(
          this.$fanyi('绑定'),
          this.$fanyi('是否绑定此邀请码，绑定成功后，不可修改！'),
          (cancel) => {
            this.$api.userPromoteBind({ invite_code: code }).then((bindRes) => {
              cancel()
              if (bindRes.code != 0) return this.$message.error(this.$fanyi(bindRes.msg))
              this.$message.success(this.$fanyi('成功'))
              this.getData()
            })
          }
        )
      })
    },
    // 修改唛头
    changeMark() {
      this.value = this.mark
      this.$refs.dialog2.open(
        '',

        (cancel) => {
          cancel()
          if (this.mark == '') {
            this.$api
              .userMarkAdd({
                mark: this.value,
                is_default: 1,
              })
              .then((res) => {

                if (res.code != 0) return

                this.getmark()
              })
          } else {
            this.$api
              .userMarkUpdate({
                id: this.markList[0].id,
                mark: this.value,
                is_default: 1,
              })
              .then((res) => {

                if (res.code != 0) return

                this.getmark()
              })
          }

        },
        () => { }
      )
    },
    // 获取唛头
    getmark() {
      this.$api.userMarkList().then((res) => {

        if (res.code != 0) return

        this.mark = res.data[0].mark
        this.markList = res.data
      })
    },
    //校验ssn
    ssnChannelInputLimit(e) {
      this.value = e.replace(/^(\w){9}$/, '')
    },
    // 修改用户名
    changeUserName(type) {
      if (type == 'name') {
        this.value = this.userDatas.user_name
        this.$refs.dialog3.open(
          '',
          (cancel) => {
            this.$api
              .userUserNameSave({ user_name: this.value })
              .then((res) => {
                cancel()
                if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))

                this.getData()
              })
          },
          () => { }
        )
      } else if (type == 'last_name') {
        this.value = this.userDatas.user_last_name
        this.$refs.dialog.open(
          '',
          (cancel) => {
            this.$api
              .userUserLastNameSave({ user_last_name: this.value })
              .then((res) => {
                cancel()
                if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))
                this.getData()
              })
          },
          () => { }
        )
      } else if (type == 'NIF') {
        this.value = this.userDatas.user_id_card
        this.$refs.dialog6.open(
          '',
          (cancel) => {
            let str = /^(\w){9}$/
            if (!str.test(this.value)) {
              this.$message.error(this.$fanyi('SSN输入错误'))
              return
            }
            cancel()
            this.$api
              .userUserIdCardSave({ user_id_card: this.value })
              .then((res) => {

                if (res.code != 0) return this.$message.error(res.msg)
                this.getData()
              })
          },
          () => { }
        )
      } else if (type == 'zhou') {
        this.value = this.userDatas.state

        this.$refs.dialog5.open(
          '',
          (cancel) => {
            this.$api.modifyzhou({ state: this.value }).then((res) => {
              cancel()
              if (res.code != 0) return this.$message.error(res.msg)
              this.getData()
            })
          },
          () => { }
        )
      } else if (type == 'Cellphone') {
        this.value = this.userDatas.mobile
        this.$refs.dialogtel.open(
          '',
          (cancel) => {
            // let str = /^(\w){10}$/
            // if (!str.test(this.value)) {
            //   this.$message.error(this.$fanyi('请输入正确的手机号'))
            //   return
            // }
            if (this.value == '') {
              this.$message.error(this.$fanyi('手机号不能为空'))
              return
            }
            cancel()
            this.$api
              .userMobileSave({ mobile: this.value })
              .then((res) => {
                if (res.code != 0) return this.$message.error(res.msg)
                this.$message({
                  message: this.$fanyi('手机号更改成功'),
                  type: 'success'
                });

                this.getData()
              })
          },
          () => { }
        )
      } else if (type == 'whatsapp') {
        this.value = this.userDatas.whatsapp
        this.$refs.dialog7.open(
          '',
          (cancel) => {
            cancel()
            this.$api
              .userWhatsappSave({ whatsapp: this.value })
              .then((res) => {
                if (res.code != 0) return this.$message.error(res.msg)
                this.getData()
              })
          },
          () => { }
        )
      } else if (type == 'telegram') {
        this.value = this.userDatas.telegram
        this.$refs.dialog9.open(
          '',
          (cancel) => {
            cancel()
            this.$api
              .userTelegramSave({ telegram: this.value })
              .then((res) => {
                if (res.code != 0) return this.$message.error(res.msg)
                this.getData()
              })
          },
          () => { }
        )
      } else if (type == 'max') {
        this.value = this.userDatas.max
        this.$refs.dialog8.open(
          '',
          (cancel) => {
            cancel()
            this.$api
              .userMaxSave({ max: this.value })
              .then((res) => {
                if (res.code != 0) return this.$message.error(res.msg)
                this.getData()
              })
          },
          () => { }
        )
      }


    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../css/mixin.scss';





.option {
  width: 360px;
  height: 48px;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #222222;
}

/deep/ .el-dialog__close {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
}

.modifydialog {
  input {
    width: 480px;
    height: 50px;
    padding: 0 15px;
    background: #FFFFFF;
    border-radius: 12px;
    border: 1px solid #DFDFDF;
  }

  /deep/.el-select {
    width: 480px;
  }

  /deep/.el-input {
    width: 480px;

    .el-input__inner {
      width: 480px;
      height: 50px;
      padding: 0px;
      background: #FFFFFF;
      border-radius: 12px;
      padding: 0 15px;
      border: 1px solid #DFDFDF;
    }
  }



}

.el-select-dropdown__item.selected {
  color: #D12A1D;
}

.userDetail {
  width: 1060px;
  min-height: 403px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 30px;

  nav {
    font-weight: 400;
    font-size: 18px;
    color: #121212;
    line-height: 24px;
    margin-bottom: 33px;
  }

  .Con {
    display: flex;
    flex-wrap: wrap;



    .ConOpt {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      width: 480px;
      min-height: 75px;
      padding: 15px 20px;
      background: #FFFFFF;
      margin-right: 20px;
      border-radius: 12px;
      border: 1px solid #DFDFDF;

      label {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;

        img {
          cursor: pointer;
        }

      }

      .userMessage {
        position: relative;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
        color: #121212;
        line-height: 20px;

        &.bind-row {
          gap: 12px;
          flex-wrap: wrap;
        }
      }

      .bind-link {
        font-weight: 400;
        font-size: 14px;
        color: #2052CE;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          text-decoration: underline;
        }
      }

      .promote-input {
        flex: 1;
        min-width: 0;
        height: 40px;
        padding: 0 12px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        font-size: 16px;
        font-weight: 400;
        color: #121212;

        &:disabled {
          background: #F5F5F5;
          cursor: not-allowed;
        }

        &:focus {
          outline: none;
          border-color: #D12A1D;
        }
      }

      .google-bind-btn {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        opacity: 0;
        pointer-events: none;
      }






    }

    .el-icon-view {
      position: absolute;
      left: 380px;
      top: 5px;
    }

    .el-button {
      width: 120px;
      height: 40px;
      background: #ff730b;
      border-radius: 4px;
      border-radius: 4px;
      margin-top: 10px;
      margin-left: 135px;
      font-size: 16px;
      color: #ffffff;
      line-height: 18px;
    }
  }
}
</style>
